import React from 'react';
import { ConfirmationModal } from 'seagull';
import { useEventReporter, useGlobalContext, useStoreActions } from "../contexts";
import { InvoiceStatus } from "../types/api.model";
const markAsPaidLoader = 'markAsPaid';
export function usePaidExternally() {
  const {
    api,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const {
    reportToHeap
  } = useEventReporter();

  function markAsPaid(invoice, onSuccess) {
    return globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;

        const closeAsCancelled = () => dismissModal(false);

        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Mark this invoice as paid externally",
          content: "By setting this invoice as paid externally, all payment processes will be stopped. Are you sure?",
          "data-testid": "mark-as-paid-confirmation-modal",
          primaryButtonLabel: "Mark as paid",
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: closeAsCancelled,
          onCloseButtonClick: closeAsCancelled,
          onPrimaryButtonClick: async () => {
            logBI(10580);
            reportToHeap('Invoice', 'click', 'mark-as-paid');

            try {
              globalContext.startLoader(markAsPaidLoader);
              await api.invoice.markAsPaidExternally(invoice.id);
              onSuccess && (await onSuccess());
              globalContext.stopLoader(markAsPaidLoader);
              dismissModal(true);
            } catch (error) {
              globalContext.stopLoader(markAsPaidLoader);
              globalContext.showErrorToast('Unable to mark the invoice as paid, please try again');
              closeAsCancelled();
            }
          }
        });
      }
    });
  }

  function shouldShowMarkAsPaid(status, isVendor) {
    if (!isVendor) {
      return false;
    }

    return [InvoiceStatus.PaymentStopped, InvoiceStatus.PaymentFailed, InvoiceStatus.Pending, InvoiceStatus.RequiresPaymentApproval].includes(status);
  }

  return {
    markAsPaid,
    shouldShowMarkAsPaid
  };
}